document.querySelectorAll(".tt-section").forEach((section) => {
  const track = section.querySelector(".tt-track");
  const wrapper = section.querySelector(".tt-track-wrapper");
  const slider = section.querySelector(".tt-slider");

  if (!track || !wrapper) return;

  const originalCards = [...track.children];
  const next = section.querySelector(".tt-next");
  const prev = section.querySelector(".tt-prev");

  const BREAKPOINTS = {
    mobile: 549,
    tablet: 1200
  };
  const SWIPE_THRESHOLD = 50;

  let perView = 3;
  let index = 0;
  let total = originalCards.length;
  let isAnimating = false;
  let canNavigate = false;
  const hasArrowButtons = Boolean(prev || next);

  function setNavigationState(showControls) {
    if (slider) slider.classList.toggle("tt-no-nav", !showControls);
    if (!hasArrowButtons) return;

    if (prev) prev.hidden = !showControls;
    if (next) next.hidden = !showControls;
  }

  function getPerView(){
    const w = window.innerWidth;
    if(w <= BREAKPOINTS.mobile) return 1;
    if(w <= BREAKPOINTS.tablet) return 2;
    return 3;
  }

  function renderStaticTrack() {
    track.innerHTML = "";
    originalCards.forEach((card) => track.appendChild(card));
    index = 0;
    track.style.transition = "none";
    track.style.transform = "translate3d(0,0,0)";
  }

  function buildTrack(){
  perView = getPerView();
  canNavigate = total > perView;

  const showControls = canNavigate && hasArrowButtons;
  setNavigationState(showControls);

  if (!canNavigate) {
    renderStaticTrack();
    return;
  }

  track.innerHTML = "";

  const before = originalCards.slice(-perView).map(el => el.cloneNode(true));
  const after  = originalCards.slice(0, perView).map(el => el.cloneNode(true));

  before.forEach(el => track.appendChild(el));
  originalCards.forEach(el => track.appendChild(el));
  after.forEach(el => track.appendChild(el));
  index = perView;
  move(false);
}

function move(animate=true){
  const width = getSlideWidth();
  if (!canNavigate || !width) return;
  const x = index * width;

  track.style.transition = animate
    ? "transform .55s cubic-bezier(.22,.61,.36,1)"
    : "none";

  track.style.transform = `translate3d(-${x}px,0,0)`;
}


function getSlideWidth(){
  const card = track.children[index];
  if (!card) return 0;
  const style = window.getComputedStyle(track);
  const gap = parseFloat(style.columnGap || style.gap || 0);

  return card.getBoundingClientRect().width + gap;
}

  track.addEventListener("transitionend", ()=>{
    if (!canNavigate) {
      isAnimating = false;
      return;
    }

    if(index >= total + perView){
  index = perView;
  move(false);
}
if(index < perView){
  index = total + perView - 1;
  move(false);
}

    isAnimating = false;
  });

  function goTo(i){
    if(!canNavigate || isAnimating) return;
    isAnimating = true;
    index = i;
    move(true);
  }

  if(next) next.addEventListener("click", ()=> goTo(index+1));
  if(prev) prev.addEventListener("click", ()=> goTo(index-1));

  let startX=0, dragging=false;

  wrapper.addEventListener("pointerdown",e=>{
    if(!canNavigate) return;
    dragging=true;
    startX=e.clientX;
    wrapper.setPointerCapture(e.pointerId);
  });

  wrapper.addEventListener("pointermove",e=>{
  if(!canNavigate || !dragging) return;
  const dx=e.clientX-startX;
  const width=getSlideWidth();
  if (!width) return;
  track.style.transition="none";
  track.style.transform = `translate3d(${-(index*width)+dx}px,0,0)`;
});

  wrapper.addEventListener("pointerup",e=>{
    if(!dragging) return;
    dragging=false;

    const dx=e.clientX-startX;

    if(Math.abs(dx)>SWIPE_THRESHOLD){
      if(dx<0) goTo(index+1);
      else goTo(index-1);
    }else{
      move(true);
    }
  });

  wrapper.addEventListener("pointercancel",()=>dragging=false);
  wrapper.addEventListener("pointerleave",()=>dragging=false);

  function refresh(){
    buildTrack();
  }

  refresh();
  window.addEventListener("resize", ()=>{
  buildTrack();
});

});
